class TOSHeroExperience {
  constructor(hero) {
    this.hero = hero;
    this.hasPlayed = false;
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.sequence = [
      ['single-shirt', 1000],
      ['print-reveal', 1000],
      ['fan-out', 900],
      ['final', 700],
    ];

    if (this.prefersReducedMotion) {
      this.showFinalState();
      return;
    }

    this.observe();
  }

  observe() {
    if (!('IntersectionObserver' in window)) {
      this.play();
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.38) {
            this.play();
            this.observer.disconnect();
          }
        });
      },
      { threshold: [0, 0.38, 1] }
    );

    this.observer.observe(this.hero);
  }

  play() {
    if (this.hasPlayed) return;
    this.hasPlayed = true;

    let elapsed = 0;

    this.sequence.forEach(([state, duration]) => {
      elapsed += duration;
      window.setTimeout(() => {
        this.hero.dataset.state = state;
      }, elapsed);
    });
  }

  showFinalState() {
    this.hero.classList.add('is-reduced-motion');
    this.hero.dataset.state = 'final';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-tos-hero]').forEach((hero) => {
    new TOSHeroExperience(hero);
  });
});
